import { render, staticRenderFns } from "./SocialPostCard.vue?vue&type=template&id=13600908"
import script from "./SocialPostCard.vue?vue&type=script&lang=js"
export * from "./SocialPostCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports